import React, { useState } from 'react';
import { BsFileText, BsPersonPlus } from 'react-icons/bs';
import { FiLock } from 'react-icons/fi';

const AssingConversationMessage = ({  
  roleId,
  agentAssigned,
  setModalTransferAgent,
  onAssignAgent,
  timerConectionChat,
  openTemplateComposer
}) => {
  const [takingConversation, setTakingConversation] = useState(false);
  const canAssignOthers = roleId == "6284fdd697029c6d9743ccb3" || roleId == "64886b1b250f9d31bf2ed68d";
  const requiresTemplate = Number(timerConectionChat) >= 24;

  const takeConversation = async () => {
    if (takingConversation) return;
    setTakingConversation(true);
    agentAssigned.current = false;
    const assigned = await onAssignAgent(
      localStorage.getItem("USER_ID"),
      localStorage.getItem("USER_NAME"),
      true
    );
    if (assigned !== false && requiresTemplate) {
      openTemplateComposer();
    }
    setTakingConversation(false);
  };

  return (
    <div className="su-conversation-gate">
      <div className="su-conversation-gate-copy">
        <span className="su-conversation-gate-icon">{requiresTemplate ? <FiLock /> : <BsPersonPlus />}</span>
        <div>
          <strong>{requiresTemplate ? "Conversación cerrada · pasaron más de 24 h" : "Nadie está atendiendo este chat"}</strong>
          <p>{requiresTemplate ? "Para retomarla, tómala y envía una plantilla aprobada por Meta." : "Tómalo para responder o asígnalo a alguien de tu equipo."}</p>
        </div>
      </div>
      <div className="su-conversation-gate-actions">
        {canAssignOthers && <button type="button" className="secondary" onClick={() => setModalTransferAgent(true)}>Asignar a…</button>}
        <button type="button" className="primary" disabled={takingConversation} onClick={takeConversation}>
          {requiresTemplate ? <BsFileText /> : <BsPersonPlus />}
          {takingConversation ? "Tomando…" : requiresTemplate ? "Tomar y enviar plantilla" : "Tomar y responder"}
        </button>
      </div>
    </div>
  );
};

export default AssingConversationMessage;
